import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import VideosPage from './pages/VideosPage';
import LivePage from './pages/LivePage';
import LiveNowPage from './pages/LiveNowPage';
import VideoPlayerPage from './pages/VideoPlayerPage';
import MerchPage from './pages/MerchPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PricingPage from './pages/PricingPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/live" element={<LivePage />} />
            <Route path="/live-now" element={<LiveNowPage />} />
            <Route path="/videos/:id" element={<VideoPlayerPage />} />
            <Route path="/merch" element={<MerchPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/pricing" element={<PricingPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
